import { HamburgerButton, HamburgerButtonProps, HamburgerHandle } from 'owa-left-rail';
import * as React from 'react';

export interface CalendarModuleHamburgerButtonProps extends HamburgerButtonProps {
    autoFocus: boolean;
}

/**
 * This wrapper component is a workaround to allow for selectively enabling autofocus,
 * in order to "preserve" focus on the button after clicking on it. Typically such a
 * workaround is not needed, however the CalendarModule component DOM is structured
 * such that the HamburgerButton component is unmounted and remounted (i.e. as a new
 * instance) every time it is clicked.
 *
 * Restructuring the DOM is difficult and expensive to do correctly without regressing
 * any of the various user permutations that are supported (i.e. left-nav expanded/collapsed
 * by left-rail visible/invisible).
 *
 * This workaround can be removed if/when the DOM can be restructured/simplified to ensure
 * that the initial component instance can be preserved in the DOM across button clicks.
 *
 * Tracking the correct fix on VSO #51744
 */
export default function CalendarModuleHamburgerButton(props: CalendarModuleHamburgerButtonProps) {
    const { autoFocus } = props;

    const buttonRef = React.useRef<HamburgerHandle>(null);

    React.useEffect(() => {
        if (autoFocus && buttonRef.current) {
            buttonRef.current.focus();
        }
    }, []);

    return <HamburgerButton ref={buttonRef} {...props} />;
}
